/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global Office */

Office.onReady(() => {
  // If needed, Office.js is ready to be called.  
});

/**
 * Shows a notification when the add-in command is executed.
 * @param event {Office.AddinCommands.Event}
 */
function action(event) {
  const message = {
    type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
    message: "Performed action.",
    icon: "Icon.80x80",
    persistent: true,
  };

  // Show a notification message.
  Office.context.mailbox.item.notificationMessages.replaceAsync(
    "ActionPerformanceNotification",
    message
  );

  // Be sure to indicate when the add-in command function is complete.
  event.completed();
}

function launchMobileTaskpane(event) {
    Office.context.ui.displayDialogAsync("https://localhost:3000/taskpane.html", { height: 50, width: 50 }, function (result) {
      // Optional: handle dialog result here
    });

    // Always signal completion of the event
    event.completed();
  }

// Register the function with Office.
//Office.actions.associate("action", action);
//Office.actions.associate("launchMobileTaskpane", launchMobileTaskpane);
